











































import { Component, Prop, Vue } from "vue-property-decorator";
import { Location } from "vue-router";

const FRAME_OVER_SIZE = 40;
const SCREEN_WIDTH = 1280;
const SCREEN_HEIGHT = 720;

@Component({})
export default class DoKoHtmlDialog extends Vue {
  @Prop({
    type: Number,
    default: 550,
  })
  private width!: number;

  @Prop({
    type: Number,
    default: 480,
  })
  private height!: number;

  @Prop({
    type: Boolean,
    default: true,
  })
  private closeable!: boolean;

  get htmlStyle() {
    return {
      height: this.height + "px",
      width: this.width + "px",
      position: "relative",
      top: FRAME_OVER_SIZE / 2 + "px",
      left: FRAME_OVER_SIZE / 2 + "px",
    };
  }

  get frameWidth() {
    return this.width + FRAME_OVER_SIZE;
  }

  get frameHeight() {
    return this.height + FRAME_OVER_SIZE;
  }

  get frameX() {
    return (SCREEN_WIDTH - this.frameWidth) / 2;
  }

  get frameY() {
    return (SCREEN_HEIGHT - this.frameHeight) / 2;
  }

  get x() {
    return (SCREEN_WIDTH - this.width) / 2;
  }
  get y() {
    return (SCREEN_HEIGHT - this.height) / 2;
  }
}
